import { Badge } from "baseui/badge";
import { Block } from "baseui/block";
import ActiveFreezeAlarms from "../../../Devices/SensorDigitalAlarm/ActiveFreezeAlarms";
import { FormattedMessage } from "react-intl";
import { useStyletron } from "baseui";
import { useGetObjectsChildren } from "../../../../hooks/useGetObjectsChildren";
import { useMemo } from "react";
import { schema as schemaMultistate, SmallPanel as MSSmallPanel } from '../../../Devices/MultiState'
import { schema as schemaMultistateSwitch, SmallPanel as MSSwitchSmallPanel } from '../../../Devices/MultiStateSwitch'

const OperationState = (props: any) => {
    const [css, theme] = useStyletron();

    const { children, isLoading, isSuccess, error } = useGetObjectsChildren(props.resourceGroupId, props.id)
    const state = useMemo(() => children?.find((v: any) => v.schema === schemaMultistate), [children]);
    const stateSW = useMemo(() => children?.find((v: any) => v.schema === schemaMultistateSwitch), [children]);

    return (<Block display={'inline-flex'} gridGap={theme.sizing.scale400}>
        {props.isOn && <Badge hierarchy='secondary' color='positive' content={<FormattedMessage id="Devices.ON" defaultMessage="On" />} />}
        {!props.isOn && <Badge hierarchy='secondary' color='primary' content={<FormattedMessage id="Devices.OFF" defaultMessage="Off" />} />}
        {stateSW && <MSSwitchSmallPanel {...stateSW}></MSSwitchSmallPanel>}
        {state  && <MSSmallPanel {...state}></MSSmallPanel>}
        <ActiveFreezeAlarms parentId={props.id} parentResourceGroupId={props.resourceGroupId}></ActiveFreezeAlarms>
    </Block>
    )
}

export default OperationState;